import '@adornis/dialog/x-drawer-panel.js';
import '@adornis/dialog/x-native-dialog.js';

export const dialogDefaultComponents = ['x-drawer-panel', 'x-native-dialog'] as `x-${string}`[];
